/* ==========================================================================
   Jay Jay Distributors — storefront
   --------------------------------------------------------------------------
   One rule governs this file: prices are never in it and never in the
   catalogue it loads. They arrive only from the JCODE-verified Shopify
   endpoint, and only after a code has been accepted. If you find yourself
   adding a price to jj-catalog.json, stop — that file is public.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = JSON.parse(document.getElementById('jj-config').textContent);
  var STORE_KEY = 'jj_jcode';
  var AGE_KEY = 'jj_age_ok';

  var state = {
    catalog: null,
    products: [],
    prices: null,      // null until a JCODE is accepted
    account: null,
    code: null,
  };

  /* ------------------------------------------------------------- helpers -- */

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') node.className = v;
      else if (k === 'html') node.innerHTML = v;
      else if (k.indexOf('on') === 0) node.addEventListener(k.slice(2).toLowerCase(), v);
      else node.setAttribute(k, v === true ? '' : v);
    });
    (children || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      node.appendChild(c.nodeType ? c : document.createTextNode(String(c)));
    });
    return node;
  }

  function money(n) {
    return '$' + Number(n).toFixed(2);
  }

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var digits = function (s) { return String(s || '').replace(/\D/g, ''); };

  /* --------------------------------------------------------- product art -- */

  /* Deterministic hue per brand: a brand's whole range hangs together on the
     grid, while different brands stay separable. */
  function brandHue(brand) {
    var h = 0;
    for (var i = 0; i < brand.length; i++) h = (h * 31 + brand.charCodeAt(i)) % 360;
    return h;
  }

  var SHAPES = {
    pouches: function (f, d) {
      return '<ellipse cx="150" cy="112" rx="74" ry="26" fill="' + f + '"/>' +
        '<path d="M76 112v42a74 26 0 0 0 148 0v-42z" fill="' + d + '"/>' +
        '<ellipse cx="150" cy="112" rx="56" ry="18" fill="' + d + '" opacity=".45"/>';
    },
    vapes: function (f, d) {
      return '<rect x="82" y="52" width="62" height="150" rx="7" fill="' + d + '"/>' +
        '<rect x="92" y="64" width="42" height="58" rx="5" fill="' + f + '" opacity=".55"/>' +
        '<rect x="160" y="30" width="36" height="172" rx="16" fill="' + f + '"/>' +
        '<rect x="168" y="42" width="20" height="46" rx="8" fill="' + d + '" opacity=".6"/>';
    },
    papers: function (f, d) {
      return '<rect x="70" y="84" width="160" height="98" rx="8" fill="' + d + '"/>' +
        '<rect x="70" y="84" width="160" height="26" rx="8" fill="' + f + '"/>' +
        '<path d="M150 84 l58-28 22 28z" fill="' + f + '" opacity=".75"/>' +
        '<rect x="86" y="126" width="128" height="7" rx="3.5" fill="' + f + '" opacity=".45"/>';
    },
    cones: function (f, d) {
      return '<path d="M118 44 l64 0 32 148 -128 0z" fill="' + f + '"/>' +
        '<path d="M150 44 l32 0 32 148 -64 0z" fill="' + d + '" opacity=".55"/>' +
        '<rect x="86" y="176" width="128" height="24" rx="6" fill="' + d + '"/>';
    },
    wraps: function (f, d) {
      return '<path d="M84 46h132a6 6 0 0 1 6 6v196a6 6 0 0 1-6 6H84a6 6 0 0 1-6-6V52a6 6 0 0 1 6-6z" fill="' + f + '"/>' +
        '<path d="M150 46h66a6 6 0 0 1 6 6v196a6 6 0 0 1-6 6h-66z" fill="' + d + '" opacity=".45"/>' +
        '<path d="M78 96h144M78 208h144" stroke="' + d + '" stroke-width="5" stroke-dasharray="9 9" opacity=".8"/>';
    },
    lighters: function (f, d) {
      return '<rect x="104" y="76" width="92" height="140" rx="18" fill="' + f + '"/>' +
        '<rect x="104" y="76" width="46" height="140" rx="18" fill="' + d + '" opacity=".35"/>' +
        '<rect x="122" y="46" width="56" height="34" rx="6" fill="' + d + '"/>' +
        '<rect x="120" y="120" width="60" height="66" rx="6" fill="' + d + '" opacity=".4"/>';
    },
    fuel: function (f, d) {
      return '<path d="M112 74h76a12 12 0 0 1 12 12v112a12 12 0 0 1-12 12h-76a12 12 0 0 1-12-12V86a12 12 0 0 1 12-12z" fill="' + f + '"/>' +
        '<rect x="136" y="40" width="28" height="38" rx="6" fill="' + d + '"/>' +
        '<rect x="116" y="106" width="68" height="52" rx="6" fill="' + d + '" opacity=".45"/>';
    },
    batteries: function (f, d) {
      return '<rect x="106" y="58" width="88" height="180" rx="10" fill="' + d + '"/>' +
        '<rect x="106" y="58" width="88" height="74" rx="10" fill="' + f + '"/>' +
        '<rect x="132" y="38" width="36" height="22" rx="5" fill="' + f + '"/>';
    },
    energy: function (f, d) {
      return '<path d="M124 78h52v14l14 18v112a10 10 0 0 1-10 10h-60a10 10 0 0 1-10-10V110l14-18z" fill="' + f + '"/>' +
        '<rect x="130" y="46" width="40" height="34" rx="6" fill="' + d + '"/>' +
        '<rect x="118" y="138" width="64" height="54" rx="6" fill="' + d + '" opacity=".5"/>';
    },
    otc: function (f, d) {
      return '<rect x="80" y="72" width="140" height="140" rx="10" fill="' + f + '"/>' +
        '<path d="M150 72h60a10 10 0 0 1 10 10v130h-70z" fill="' + d + '" opacity=".4"/>' +
        '<rect x="102" y="120" width="96" height="16" rx="8" fill="' + d + '" opacity=".8"/>' +
        '<rect x="142" y="96" width="16" height="64" rx="8" fill="' + d + '" opacity=".8"/>';
    },
    lipcare: function (f, d) {
      return '<rect x="126" y="56" width="48" height="176" rx="12" fill="' + f + '"/>' +
        '<rect x="126" y="56" width="24" height="176" rx="12" fill="' + d + '" opacity=".35"/>' +
        '<rect x="118" y="112" width="64" height="26" rx="6" fill="' + d + '"/>';
    },
    personalcare: function (f, d) {
      return '<path d="M118 84h64a14 14 0 0 1 14 14v118a14 14 0 0 1-14 14h-64a14 14 0 0 1-14-14V98a14 14 0 0 1 14-14z" fill="' + f + '"/>' +
        '<rect x="130" y="42" width="40" height="44" rx="8" fill="' + d + '"/>' +
        '<ellipse cx="150" cy="150" rx="30" ry="30" fill="' + d + '" opacity=".4"/>';
    },
    oralcare: function (f, d) {
      return '<path d="M92 168c0-16 22-24 58-24s58 8 58 24-22 26-58 26-58-10-58-26z" fill="' + d + '"/>' +
        '<path d="M96 156c14-52 34-92 54-92s40 40 54 92z" fill="' + f + '"/>' +
        '<rect x="128" y="44" width="44" height="22" rx="8" fill="' + d + '"/>';
    },
    condoms: function (f, d) {
      return '<rect x="76" y="88" width="148" height="118" rx="8" fill="' + f + '"/>' +
        '<path d="M150 88h74v118h-74z" fill="' + d + '" opacity=".4"/>' +
        '<path d="M76 106h148M76 190h148" stroke="' + d + '" stroke-width="5" stroke-dasharray="8 8"/>';
    },
    botanicals: function (f, d) {
      return '<path d="M116 90h68a8 8 0 0 1 8 8v112a14 14 0 0 1-14 14h-56a14 14 0 0 1-14-14V98a8 8 0 0 1 8-8z" fill="' + f + '"/>' +
        '<rect x="132" y="48" width="36" height="44" rx="6" fill="' + d + '"/>' +
        '<path d="M108 148h84v62a14 14 0 0 1-14 14h-56a14 14 0 0 1-14-14z" fill="' + d + '" opacity=".45"/>';
    },
    general: function (f, d) {
      return '<path d="M78 106l72-32 72 32v100l-72 32-72-32z" fill="' + f + '"/>' +
        '<path d="M150 74l72 32v100l-72 32z" fill="' + d + '" opacity=".45"/>';
    },
  };

  function shortName(p) {
    var n = p.n.replace(/\s*\(.*?\)\s*/g, ' ')
      .replace(/\b\d+\s*(?:CT|PCS|PK|PACK|PACKS|CARDS|CONES|WRAPS|TIPS)\b/gi, '')
      .replace(/\bPer Box\b/gi, '').replace(/\s{2,}/g, ' ').trim();
    return (n.length > 32 ? n.slice(0, 30).trim() + '…' : n) || p.n.slice(0, 30);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function productArt(p) {
    var hue = brandHue(p.b);
    var fill = 'hsl(' + hue + ' 42% 58%)';
    var dark = 'hsl(' + hue + ' 46% 40%)';
    var wash = 'hsl(' + hue + ' 40% 96%)';
    var maker = SHAPES[p.g] || SHAPES.general;
    if (p.g === 'papers') maker = /cone|rawket|peacemaker/i.test(p.n) ? SHAPES.cones : SHAPES.papers;

    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" width="300" height="300">' +
      '<defs><linearGradient id="g" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="#ffffff"/><stop offset="1" stop-color="' + wash + '"/>' +
      '</linearGradient></defs>' +
      '<rect width="300" height="300" fill="url(#g)"/>' +
      '<ellipse cx="150" cy="243" rx="86" ry="13" fill="hsl(' + hue + ' 30% 45%)" opacity=".14"/>' +
      '<g transform="translate(0,-14)">' + maker(fill, dark) + '</g>' +
      '<text x="150" y="268" text-anchor="middle" font-family="Helvetica,Arial,sans-serif" font-weight="700" font-size="17" fill="#1a1512">' + esc(p.b.toUpperCase()) + '</text>' +
      '<text x="150" y="286" text-anchor="middle" font-family="monospace" font-size="10.5" fill="#7a736c">' + esc(shortName(p).toUpperCase()) + '</text>' +
      '</svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }



  /* Use real product photos uploaded to Shopify Content > Files.
   Filename must match catalogue code exactly: N2000.webp, C1000.webp, etc.
   If no matching photo exists, generated artwork is used instead. */
function imageFor(p) {
  var img = el('img', {
    src: 'https://cdn.shopify.com/s/files/1/0771/5795/7949/files/' + p.s + '.webp',
    alt: p.b + ' ' + p.n,
    loading: 'lazy',
    width: '300',
    height: '300',
  });

  img.addEventListener('error', function handle() {
    img.removeEventListener('error', handle);
    img.src = productArt(p);
  });

  return img;
}

  /* ------------------------------------------------------------- pricing -- */

  function priceSlot(p, animate) {
    var row = state.prices ? state.prices[p.s] : null;

    if (!state.prices) {
      return el('button', {
        class: 'price-lock', type: 'button',
        'aria-label': 'Prices are locked. Enter a JCODE to see pricing for ' + p.c + '.',
        onclick: function (e) { e.preventDefault(); e.stopPropagation(); openUnlock(); },
      }, [
        /* Placeholder digits. The real figure was never sent to this browser. */
        el('span', { class: 'price-lock__blur', 'aria-hidden': 'true' }, ['$00.00']),
        el('span', { class: 'price-lock__key' }, ['Unlock']),
      ]);
    }

    if (!row) {
      return el('span', { class: 'price-ask' }, [
        'Price on request — ',
        el('a', { href: 'tel:' + digits(CFG.company.work) }, [CFG.company.work]),
      ]);
    }

    return el('span', { class: 'price' + (animate ? ' price--revealed' : '') }, [
      money(row.p),
      row.u ? el('span', { class: 'price__unit' }, [' / ' + row.u]) : null,
    ]);
  }

  function productCard(p, animate) {
    var tags = [];
    if (p.a) { if (p.a.strength) tags.push(p.a.strength); if (p.a.size) tags.push(p.a.size); }
    var critical = (p.w || []).indexOf('nicotine-warning') > -1;

    return el('article', { class: 'card' }, [
      el('div', { class: 'card__media' }, [imageFor(p)]),
      el('div', { class: 'card__body' }, [
        el('p', { class: 'card__brand' }, [p.b]),
        el('a', {
          class: 'card__name', href: CFG.routes.catalog + '?p=' + encodeURIComponent(p.s),
          onclick: function (e) { e.preventDefault(); showProduct(p.s, true); },
        }, [p.n]),
        el('div', { class: 'card__meta' }, [
          el('span', { class: 'code' }, [p.c]),
        ].concat(tags.slice(0, 2).map(function (t) { return el('span', { class: 'card__tag' }, [t]); }))),
        el('div', { class: 'card__foot' }, [
          el('div', { class: 'price-slot' }, [priceSlot(p, animate)]),
          critical ? el('p', { class: 'card__warn' }, ['⚠ Contains nicotine']) : null,
        ]),
      ]),
    ]);
  }

  /* -------------------------------------------------------------- unlock -- */

  function setUnlockUi() {
    var on = !!state.prices;
    document.body.classList.toggle('is-unlocked', on);
    qsa('[data-unlock-status]').forEach(function (n) {
      n.textContent = on ? 'Prices unlocked' + (state.account ? ' · ' + state.account : '') : 'Prices locked';
    });
    qsa('[data-unlock-btn]').forEach(function (b) {
      b.textContent = on ? 'Lock prices' : 'Unlock prices';
      b.onclick = on ? lockPrices : openUnlock;
    });
  }

  /* Asks Shopify to check the code. Prices come back only if it is valid. */
  function verify(code) {
    return fetch(CFG.priceEndpoint + encodeURIComponent(code), {
      headers: { 'X-Requested-With': 'fetch' },
    }).then(function (r) { return r.text(); }).then(function (text) {
      var data;
      try { data = JSON.parse(text.trim()); }
      catch (err) { throw new Error('Could not reach the pricing service. Please try again.'); }
      if (!data.ok) throw new Error("That JCODE isn't recognised. Check it and try again.");
      return data;
    });
  }

  function applyUnlock(data, code) {
    state.prices = data.prices || {};
    state.account = data.account || null;
    state.code = code;
    try { localStorage.setItem(STORE_KEY, code); } catch (e) { /* private mode */ }
    setUnlockUi();
    document.dispatchEvent(new CustomEvent('jj:unlocked'));
  }

  function lockPrices() {
    state.prices = null;
    state.account = null;
    state.code = null;
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    setUnlockUi();
    document.dispatchEvent(new CustomEvent('jj:locked'));
  }

  function openUnlock() {
    var modal = qs('#jj-unlock');
    if (!modal) { window.location.href = CFG.routes.jcode; return; }
    modal.hidden = false;
    qs('[data-unlock-error]', modal).hidden = true;
    var input = qs('[data-unlock-input]', modal);
    input.value = '';
    input.focus();
  }

  function closeUnlock() {
    var modal = qs('#jj-unlock');
    if (modal) modal.hidden = true;
  }

  function wireUnlockForm(form) {
    if (!form || form.dataset.wired) return;
    form.dataset.wired = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = qs('[data-unlock-input]', form) || qs('input', form);
      var error = qs('[data-unlock-error]', form.closest('[data-unlock-scope]') || form) || qs('[data-unlock-error]', form);
      var button = qs('button[type=submit]', form) || qs('button', form);
      var label = button.textContent;
      if (error) error.hidden = true;
      button.disabled = true;
      button.textContent = 'Checking…';
      verify(input.value)
        .then(function (data) {
          applyUnlock(data, input.value.trim().toUpperCase());
          closeUnlock();
          if (form.dataset.reload === 'true') window.location.reload();
        })
        .catch(function (err) {
          if (error) { error.textContent = err.message; error.hidden = false; }
          input.select();
        })
        .then(function () {
          button.disabled = false;
          button.textContent = label;
        });
    });
  }

  /* ------------------------------------------------------------ age gate -- */

  function ageGate() {
    var gate = qs('#jj-agegate');
    if (!gate) return;
    var ok = false;
    try { ok = localStorage.getItem(AGE_KEY) === 'yes'; } catch (e) { ok = false; }
    if (ok) return;

    gate.hidden = false;
    document.body.style.overflow = 'hidden';
    qs('[data-age-yes]', gate).addEventListener('click', function () {
      try { localStorage.setItem(AGE_KEY, 'yes'); } catch (e) {}
      gate.remove();
      document.body.style.overflow = '';
    });
    qs('[data-age-no]', gate).addEventListener('click', function () {
      qs('[data-age-deny]', gate).hidden = false;
    });
  }

  /* ------------------------------------------------------------- catalog -- */

  var view = {
    q: '', category: '', brands: [], strengths: [], sizes: [], sort: 'code', page: 1,
  };

  function readUrl() {
    var p = new URLSearchParams(window.location.search);
    view.q = p.get('q') || '';
    view.category = p.get('category') || '';
    view.brands = (p.get('brand') || '').split(',').filter(Boolean);
    view.strengths = (p.get('strength') || '').split(',').filter(Boolean);
    view.sizes = (p.get('size') || '').split(',').filter(Boolean);
    view.sort = p.get('sort') || 'code';
    view.page = Number(p.get('page') || 1);
    return p.get('p');
  }

  function writeUrl(resetPage) {
    var p = new URLSearchParams();
    if (view.category) p.set('category', view.category);
    if (view.q) p.set('q', view.q);
    if (view.brands.length) p.set('brand', view.brands.join(','));
    if (view.strengths.length) p.set('strength', view.strengths.join(','));
    if (view.sizes.length) p.set('size', view.sizes.join(','));
    if (view.sort !== 'code') p.set('sort', view.sort);
    var page = resetPage ? 1 : view.page;
    if (resetPage) view.page = 1;
    if (page > 1) p.set('page', String(page));
    var url = CFG.routes.catalog + (p.toString() ? '?' + p : '');
    window.history.pushState({}, '', url);
    renderCatalog();
  }

  function matches(p) {
    if (view.category && p.g !== view.category) return false;
    if (view.brands.length && view.brands.indexOf(p.b) < 0) return false;
    if (view.strengths.length && (!p.a || view.strengths.indexOf(p.a.strength) < 0)) return false;
    if (view.sizes.length && (!p.a || view.sizes.indexOf(p.a.size) < 0)) return false;
    if (view.q) {
      var hay = (p.s + ' ' + p.n + ' ' + p.b + ' ' + (p.u || '')).toLowerCase();
      var terms = view.q.toLowerCase().split(/\s+/).filter(Boolean);
      for (var i = 0; i < terms.length; i++) if (hay.indexOf(terms[i]) < 0) return false;
    }
    return true;
  }

  var SORTS = {
    code: function (a, b) { return a.s.localeCompare(b.s, undefined, { numeric: true }); },
    name: function (a, b) { return a.n.localeCompare(b.n); },
    brand: function (a, b) { return a.b.localeCompare(b.b) || a.s.localeCompare(b.s, undefined, { numeric: true }); },
  };

  function facetCounts(getter) {
    var scope = state.products.filter(function (p) { return !view.category || p.g === view.category; });
    var counts = {};
    scope.forEach(function (p) {
      var v = getter(p);
      if (v) counts[v] = (counts[v] || 0) + 1;
    });
    return Object.keys(counts).map(function (k) { return { value: k, count: counts[k] }; })
      .sort(function (a, b) { return b.count - a.count; });
  }

  function facetGroup(title, key, options) {
    if (!options.length) return null;
    var selected = view[key];
    return el('div', { class: 'facet' }, [
      el('p', { class: 'facet__head', style: 'cursor:default' }, [title]),
      el('ul', { class: 'facet__list' }, options.map(function (opt) {
        return el('li', {}, [
          el('label', {}, [
            el('input', {
              type: 'checkbox', checked: selected.indexOf(opt.value) > -1,
              onchange: function () {
                var i = selected.indexOf(opt.value);
                if (i > -1) selected.splice(i, 1); else selected.push(opt.value);
                writeUrl(true);
              },
            }),
            el('span', {}, [opt.value]),
            el('span', { class: 'facet__n' }, [String(opt.count)]),
          ]),
        ]);
      })),
    ]);
  }

  function renderFacets() {
    var box = qs('[data-facets]');
    if (!box) return;
    var cats = el('div', { class: 'facet' }, [
      el('p', { class: 'facet__head', style: 'cursor:default' }, ['Category']),
      el('ul', { class: 'facet__list' }, [
        el('li', {}, [el('label', {}, [
          el('input', {
            type: 'radio', name: 'jjcat', checked: !view.category,
            onchange: function () { view.category = ''; view.brands = []; view.strengths = []; view.sizes = []; writeUrl(true); },
          }),
          el('span', {}, ['All products']),
          el('span', { class: 'facet__n' }, [String(state.products.length)]),
        ])]),
      ].concat(state.catalog.categories.map(function (c) {
        return el('li', {}, [el('label', {}, [
          el('input', {
            type: 'radio', name: 'jjcat', checked: view.category === c.slug,
            onchange: function () { view.category = c.slug; view.brands = []; view.strengths = []; view.sizes = []; writeUrl(true); },
          }),
          el('span', {}, [c.name]),
          el('span', { class: 'facet__n' }, [String(c.count)]),
        ])]);
      }))),
    ]);

    box.replaceChildren(
      cats,
      facetGroup('Brand', 'brands', facetCounts(function (p) { return p.b; })),
      facetGroup('Strength', 'strengths', facetCounts(function (p) { return p.a && p.a.strength; })
        .sort(function (a, b) { return parseFloat(a.value) - parseFloat(b.value); })),
      facetGroup('Size', 'sizes', facetCounts(function (p) { return p.a && p.a.size; }))
    );
  }

  function renderChips() {
    var box = qs('[data-chips]');
    if (!box) return;
    var chips = [];
    function chip(label, onRemove) {
      return el('span', { class: 'chip' }, [label,
        el('button', { type: 'button', 'aria-label': 'Remove ' + label, onclick: onRemove }, ['×'])]);
    }
    if (view.q) chips.push(chip('“' + view.q + '”', function () { view.q = ''; writeUrl(true); }));
    ['brands', 'strengths', 'sizes'].forEach(function (key) {
      view[key].slice().forEach(function (value) {
        chips.push(chip(value, function () {
          view[key].splice(view[key].indexOf(value), 1); writeUrl(true);
        }));
      });
    });
    if (chips.length > 1) {
      chips.push(el('button', {
        class: 'chip', type: 'button', style: 'font-weight:600',
        onclick: function () { view.q = ''; view.brands = []; view.strengths = []; view.sizes = []; writeUrl(true); },
      }, ['Clear all']));
    }
    box.replaceChildren.apply(box, chips);
  }

  function renderCatalog(animate) {
    var grid = qs('[data-grid]');
    if (!grid) return;

    qs('[data-detail]').hidden = true;
    qs('[data-browse]').hidden = false;

    var items = state.products.filter(matches).sort(SORTS[view.sort] || SORTS.code);
    var per = 36;
    var pages = Math.max(Math.ceil(items.length / per), 1);
    if (view.page > pages) view.page = pages;
    var slice = items.slice((view.page - 1) * per, view.page * per);

    var cat = null;
    state.catalog.categories.forEach(function (c) { if (c.slug === view.category) cat = c; });
    var title = cat ? cat.name : view.q ? 'Results for “' + view.q + '”' : 'All products';
    qs('[data-browse-title]').textContent = title;
    qs('[data-browse-lede]').textContent = cat ? cat.blurb
      : 'The complete Jay Jay Distributors range, straight from the ' + CFG.company.catalogue + ' catalogue.';
    document.title = title + ' — ' + CFG.company.name;

    var count = qs('[data-count]');
    count.replaceChildren(el('b', {}, [String(items.length)]),
      document.createTextNode(items.length === 1 ? ' product' : ' products'));

    var sortSel = qs('[data-sort]');
    if (sortSel) sortSel.value = view.sort;

    renderFacets();
    renderChips();

    if (!slice.length) {
      grid.replaceChildren(el('div', { class: 'empty', style: 'grid-column:1/-1' }, [
        el('h3', {}, ['Nothing matches those filters']),
        el('p', {}, ['Try removing a filter, or search by catalogue code — every product has one.']),
      ]));
    } else {
      grid.replaceChildren.apply(grid, slice.map(function (p, i) {
        var card = productCard(p, animate);
        if (animate) {
          var price = qs('.price--revealed', card);
          if (price) price.style.animationDelay = Math.min(i * 28, 700) + 'ms';
        }
        return card;
      }));
    }

    var pager = qs('[data-pager]');
    if (pages <= 1) pager.replaceChildren();
    else {
      pager.replaceChildren(
        el('button', {
          class: 'btn btn--ghost btn--sm', type: 'button', disabled: view.page <= 1,
          onclick: function () { view.page--; writeUrl(false); window.scrollTo({ top: 0, behavior: 'smooth' }); },
        }, ['← Previous']),
        el('span', { class: 'pager__info' }, ['Page ' + view.page + ' of ' + pages]),
        el('button', {
          class: 'btn btn--ghost btn--sm', type: 'button', disabled: view.page >= pages,
          onclick: function () { view.page++; writeUrl(false); window.scrollTo({ top: 0, behavior: 'smooth' }); },
        }, ['Next →'])
      );
    }
  }

  /* ------------------------------------------------------ product detail -- */

  function showProduct(sku, push) {
    var p = null;
    state.products.forEach(function (x) { if (x.s === sku) p = x; });
    if (!p) { renderCatalog(); return; }

    if (push) window.history.pushState({}, '', CFG.routes.catalog + '?p=' + encodeURIComponent(sku));

    var cat = null;
    state.catalog.categories.forEach(function (c) { if (c.slug === p.g) cat = c; });
    document.title = p.b + ' ' + p.n + ' (' + p.c + ') — ' + CFG.company.name;

    var pageNum = String(p.p).replace(/^(\d)$/, '0$1');
    var scan = CFG.assetBase + 'jj-page-' + pageNum + '.jpg';
    var row = state.prices ? state.prices[p.s] : null;

    var buyRows = [
      el('div', { class: 'buybox__row' }, [
        el('div', {}, [
          el('p', { style: 'margin:0 0 .2rem;font-size:.74rem;letter-spacing:.08em;text-transform:uppercase;color:var(--slate)' }, ['Wholesale price']),
          el('div', { class: 'price-slot' }, [priceSlot(p, false)]),
        ]),
        el('span', { class: 'code', style: 'font-size:.82rem;padding:.35rem .6rem' }, [p.c]),
      ]),
    ];

    if (!state.prices) {
      buyRows.push(el('p', { style: 'margin:.9rem 0 0;font-size:.86rem;color:var(--slate)' }, [
        'Pricing is reserved for account holders. ',
        el('button', { type: 'button', class: 'btn btn--sm btn--brass', style: 'margin-left:.3rem', onclick: openUnlock }, ['Enter JCODE']),
      ]));
    } else {
      if (row && row.c) {
        buyRows.push(el('p', { style: 'margin:.8rem 0 0;font-size:.88rem' }, [el('b', {}, ['Case pack: ']), row.c]));
      }
      buyRows.push(el('p', { style: 'margin:.55rem 0 0;font-size:.84rem;color:var(--slate)' },
        ['Order by phone or email — quote the catalogue code above.']));
      buyRows.push(el('div', { style: 'display:flex;gap:.6rem;margin-top:1rem;flex-wrap:wrap' }, [
        el('a', { class: 'btn btn--primary btn--sm', href: 'tel:' + digits(CFG.company.work) }, ['Call ' + CFG.company.work]),
        el('a', {
          class: 'btn btn--ghost btn--sm',
          href: 'mailto:' + CFG.company.email + '?subject=' + encodeURIComponent('Order enquiry — ' + p.c + ' ' + p.b + ' ' + p.n),
        }, ['Email an order']),
      ]));
    }

    var specRows = [['Catalogue code', p.c], ['Brand', p.b]];
    if (p.u) specRows.push(['Range', p.u]);
    specRows.push(['Category', cat ? cat.name : p.g]);
    if (p.a && p.a.strength) specRows.push(['Strength', p.a.strength]);
    if (p.a && p.a.size) specRows.push(['Size', p.a.size]);
    if (p.a && p.a.count) specRows.push(['Pack', p.a.count]);
    specRows.push(['Catalogue page', 'Page ' + p.p + ' of the ' + CFG.company.catalogue]);

    var related = state.products.filter(function (x) { return x.b === p.b && x.s !== p.s; }).slice(0, 8);

    var detail = qs('[data-detail]');
    detail.replaceChildren(
      el('nav', { 'aria-label': 'Breadcrumb', style: 'padding:1.5rem 0 0;font-size:.84rem;color:var(--slate)' }, [
        el('a', { href: CFG.routes.catalog, style: 'text-decoration:none',
          onclick: function (e) { e.preventDefault(); view.category = ''; writeUrl(true); } }, ['Catalogue']),
        ' / ',
        el('a', {
          href: CFG.routes.catalog + '?category=' + p.g, style: 'text-decoration:none',
          onclick: function (e) { e.preventDefault(); view.category = p.g; writeUrl(true); },
        }, [cat ? cat.name : p.g]),
        ' / ', el('span', { style: 'color:var(--ink)' }, [p.c]),
      ]),
      el('div', { class: 'pdp' }, [
        el('div', {}, [
          el('div', { class: 'pdp__media' }, [imageFor(p)]),
          el('div', { class: 'cat-ref' }, [
            el('p', { class: 'eyebrow' }, ['As printed — page ' + p.p]),
            el('a', { href: scan, target: '_blank', rel: 'noopener' }, [
              el('img', { src: scan, alt: 'Catalogue page ' + p.p, loading: 'lazy' }),
            ]),
          ]),
        ]),
        el('div', {}, [
          el('p', { class: 'pdp__brand' }, [p.b + (p.u ? ' · ' + p.u : '')]),
          el('h1', { class: 'pdp__title' }, [p.n]),
          el('p', { class: 'pdp__desc' }, [p.d]),
          el('div', { class: 'buybox' }, buyRows),
          el('table', { class: 'spec' }, [
            el('tbody', {}, specRows.map(function (r) {
              return el('tr', {}, [el('th', { scope: 'row' }, [r[0]]), el('td', {}, [r[1]])]);
            })),
          ]),
          (p.w && p.w.length) ? el('div', { style: 'margin-top:1.6rem' }, [
            el('p', { class: 'eyebrow' }, ['Compliance']),
          ].concat(p.w.map(function (key) {
            var w = state.catalog.warnings[key];
            if (!w) return null;
            return el('div', { class: 'warn-block warn-block--' + w.level }, [
              el('strong', {}, [w.title]), w.body,
            ]);
          }))) : null,
        ]),
      ]),
      related.length ? el('section', { class: 'section', style: 'padding-top:1rem' }, [
        el('div', { class: 'section__head' }, [
          el('div', {}, [
            el('p', { class: 'eyebrow' }, ['Same brand']),
            el('h2', { class: 'section__title', style: 'font-size:1.5rem' }, ['More from ' + p.b]),
          ]),
        ]),
        el('div', { class: 'grid' }, related.map(function (r) { return productCard(r, false); })),
      ]) : null
    );

    qs('[data-browse]').hidden = true;
    detail.hidden = false;
    window.scrollTo({ top: 0 });
  }

  /* ------------------------------------------------------ page bootstraps -- */

  function loadCatalog() {
    return new Promise(function (resolve, reject) {
      var data = window.JJ_CATALOG;
      if (!data || !data.products) { reject(new Error('Catalogue not loaded')); return; }
      state.catalog = data;
      state.products = data.products;
      resolve(data);
    });
  }

  function bootCatalogPage() {
    var grid = qs('[data-grid]');
    if (!grid) return;

    loadCatalog().then(function () {
      var sku = readUrl();
      var search = qs('[data-catalog-search]');
      if (search) {
        search.value = view.q;
        search.form.addEventListener('submit', function (e) {
          e.preventDefault(); view.q = search.value.trim(); writeUrl(true);
        });
      }
      var sortSel = qs('[data-sort]');
      if (sortSel) sortSel.addEventListener('change', function () { view.sort = sortSel.value; writeUrl(true); });
      var toggle = qs('[data-facet-toggle]');
      if (toggle) toggle.addEventListener('click', function () { qs('[data-facets]').classList.toggle('is-open'); });

      window.addEventListener('popstate', function () {
        var s = readUrl();
        if (s) showProduct(s, false); else renderCatalog();
      });

      if (sku) showProduct(sku, false); else renderCatalog();
    }).catch(function () {
      grid.replaceChildren(el('div', { class: 'empty', style: 'grid-column:1/-1' }, [
        el('h3', {}, ['The catalogue could not be loaded']),
        el('p', {}, ['Refresh the page. If it keeps happening, call 201-773-6999.']),
      ]));
    });
  }

  function bootHomeFeatured() {
    var box = qs('[data-featured]');
    if (!box) return;
    var picks = ['N2000', 'N2028', 'N1006', 'C1000', 'C1042', 'C9001', 'H1022', 'E3004', 'G4001', 'G3004', 'N4012', 'C8009'];
    loadCatalog().then(function (data) {
      var byId = {};
      data.products.forEach(function (p) { byId[p.s] = p; });

      var stats = qs('[data-hero-stats]');
      if (stats) {
        stats.replaceChildren(
          el('div', { class: 'hero__stat' }, [el('b', {}, [String(data.meta.productCount)]), el('span', {}, ['SKUs listed'])]),
          el('div', { class: 'hero__stat' }, [el('b', {}, [String(data.brands.length)]), el('span', {}, ['Brands stocked'])]),
          el('div', { class: 'hero__stat' }, [el('b', {}, [String(data.categories.length)]), el('span', {}, ['Categories'])]),
          el('div', { class: 'hero__stat' }, [el('b', {}, ['56']), el('span', {}, ['Catalogue pages'])])
        );
      }

      var line = qs('[data-brandline]');
      if (line) {
        line.replaceChildren.apply(line, data.brands.concat(data.brands).map(function (b) {
          return el('span', {}, [b]);
        }));
      }

      var cats = qs('[data-categories]');
      if (cats) {
        cats.replaceChildren.apply(cats, data.categories.map(function (c) {
          return el('a', { class: 'cat-tile', href: CFG.routes.catalog + '?category=' + c.slug }, [
            el('span', { class: 'cat-tile__count' }, [c.count + ' SKUs']),
            el('h3', { class: 'cat-tile__name' }, [c.name]),
            el('p', { class: 'cat-tile__blurb' }, [c.blurb]),
          ]);
        }));
      }

      var shown = picks.map(function (s) { return byId[s]; }).filter(Boolean);
      box.replaceChildren.apply(box, shown.map(function (p) { return productCard(p, false); }));
    });
  }

  function repaint() {
    if (qs('[data-grid]')) {
      var sku = new URLSearchParams(window.location.search).get('p');
      if (sku && !qs('[data-detail]').hidden) showProduct(sku, false);
      else renderCatalog(true);
    }
    if (qs('[data-featured]')) {
      qsa('[data-featured] .card').forEach(function (c) { c.remove(); });
      bootHomeFeatured();
    }
  }

  /* ----------------------------------------------------------------- go --- */

  function init() {
    ageGate();
    qsa('[data-unlock-form]').forEach(wireUnlockForm);
    setUnlockUi();

    var modal = qs('#jj-unlock');
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) closeUnlock(); });
      qsa('[data-unlock-cancel]', modal).forEach(function (b) { b.addEventListener('click', closeUnlock); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeUnlock(); });
    }

    document.addEventListener('jj:unlocked', repaint);
    document.addEventListener('jj:locked', repaint);

    bootCatalogPage();
    bootHomeFeatured();

    /* A stored code is re-checked with Shopify on every page load. Revoke a
       code in the theme and the customer loses access immediately. */
    var saved = null;
    try { saved = localStorage.getItem(STORE_KEY); } catch (e) {}
    if (saved) {
      verify(saved)
        .then(function (data) { applyUnlock(data, saved); })
        .catch(function () { lockPrices(); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.JJ = { openUnlock: openUnlock, lock: lockPrices, state: state };
}());
